import configStore from "./configStore";
import history from "./history";

const store = configStore(history);

export default store;
